import { render } from "./BarChartCt.vue?vue&type=template&id=1a272f26&scoped=true"
import script from "./BarChartCt.vue?vue&type=script&lang=js"
export * from "./BarChartCt.vue?vue&type=script&lang=js"

import "./BarChartCt.vue?vue&type=style&index=0&id=1a272f26&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a272f26"]])

export default __exports__